export enum OriginContact {
	SE_LOGER = 1,
	BIEN_ICI = 2,
	LE_BON_COIN = 3,
	PANNEAU_SUR_RESIDENCE = 6,
	RELATION = 7,
	AUTRE = 8
}